'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconChartDiagram, iconChartDiagramTag } from '@ni/nimble-components/dist/esm/icons/chart-diagram';
import { wrap } from '../../utilities/react-wrapper';

export type { IconChartDiagram };
export { iconChartDiagramTag };
export const NimbleIconChartDiagram = wrap(IconChartDiagram);